import { Outlet } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-casino-gradient" />
      <div className="absolute inset-0 bg-felt-texture opacity-30" />

      {/* Gold decorative corners */}
      <div className="absolute top-0 left-0 w-32 h-32 border-l-2 border-t-2 border-casino-gold/30" />
      <div className="absolute top-0 right-0 w-32 h-32 border-r-2 border-t-2 border-casino-gold/30" />
      <div className="absolute bottom-0 left-0 w-32 h-32 border-l-2 border-b-2 border-casino-gold/30" />
      <div className="absolute bottom-0 right-0 w-32 h-32 border-r-2 border-b-2 border-casino-gold/30" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-24 h-24 mx-auto mb-4 rounded-full border-4 border-casino-gold shadow-gold-lg bg-casino-black-light flex items-center justify-center">
            <span className="text-5xl">🎰</span>
          </div>
          <h1 className="font-cinzel text-3xl text-casino-gold font-bold tracking-wider">
            COSA NOSTRA
          </h1>
          <p className="font-cinzel text-sm text-casino-gold/70 tracking-widest">
            CASINO
          </p>
        </div>

        {/* Auth content */}
        <Outlet />

        {/* Footer */}
        <p className="text-gray-500 text-xs mt-8 text-center">
          Solo para mayores de 18 años. Juega responsablemente.
        </p>
      </div>
    </div>
  )
}
